export default "__VITE_ASSET__C0Xqp72X__"